import { CircleInfoSolidIcon, Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../Translations';

function Header() {
  return (
    <div className="p-4 pb-6">
      <img src="/exo-logo.png" className="mb-2" alt="EXO Logo" />
      <Typography fontWeight="semibold" variant="subtitleLarge">
        <T kind="EXO" />
      </Typography>
      <div className="flex items-center">
        <Typography variant="bodyMedium" fontWeight="normal" className="text-gray-600">
          <T kind="Your AI Advisor" />
        </Typography>
      </div>
      <div className="flex px-3 py-4 rounded-md mt-4 bg-blue-50 ">
        <CircleInfoSolidIcon size="lg" className="mr-3 fill-blue-500 align-baseline" />
        <div className="flex flex-col max-w-72">
          <Typography variant="bodyMedium" color="black" fontWeight="light">
            <T kind="I’m here to assist you in creating a learning collection tailored to any cohort of leaders." />
          </Typography>
          <Typography className="mt-2" variant="bodyMedium" color="black" fontWeight="light">
            <T kind="Your feedback is invaluable in helping me improve - please share your thoughts and suggestions frequently!" />
          </Typography>
        </div>
      </div>
    </div>
  );
}
export default observer(Header);
